import * as React from "react";
import {DateInput, required} from "react-admin";

const minDate = (min) => (value) => {
    if (!value) return undefined;
    const v = value instanceof Date ? value : new Date(value);
    v.setHours(0, 0, 0, 0);
    return min > v ? "Phải chọn ngày lớn hơn hôm nay" : undefined;
};
const fromNotAfterToValidator = (value, allValues) => {
    if (!value || !allValues?.cancelToDate) return undefined;

    const from = new Date(value);
    const to = new Date(allValues.cancelToDate);

    from.setHours(0, 0, 0, 0);
    to.setHours(0, 0, 0, 0);

    return from > to ? "Từ ngày phải trước đến ngày" : undefined;
};

export const CancelFromDateInput = (props) => {
    const tomorrowDate = React.useMemo(() => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);

    const validate = React.useMemo(
        () => [required(), minDate(tomorrowDate), fromNotAfterToValidator],
        [tomorrowDate]
    );

    return (
        <DateInput
            source="cancelFromDate"
            validate={validate}
            {...props}
        />
    );
};
